module.exports = __webpack_public_path__ + "static/media/formula_figma_image.8c605f08.png";